import { INITIAL_STATE } from './';
import { ActionTypes } from '../actions/action-types';

const messages = (state = INITIAL_STATE.messages, action = {}) => {
  switch (action.type) {
    case ActionTypes.MESSAGES_BE_REQUEST:
      return { ...state, activeRequests: state.activeRequests + 1 };
    case ActionTypes.MESSAGES_BE_REQUEST_RESET:
      return { ...state, activeRequests: 0 };
    case ActionTypes.MESSAGES_BE_REQUEST_COMPLETED:
      return {
        ...state,
        activeRequests: state.activeRequests > 0 ? state.activeRequests - 1 : 0
      };
    case ActionTypes.MESSAGES_SET_CACHE:
      return { ...state, cache: action.payload };
    case ActionTypes.MESSAGES_SET_FOLDER_CACHE: {
      const newState = { ...state };
      newState.cache = { ...newState.cache };
      newState.cache[action.payload.folder.folderId] = Object.fromEntries(
        action.payload.messages.map(m => [m.uid, m])
      );
      return newState;
    }
    case ActionTypes.MESSAGES_UPDATE_CACHE: {
      const { folder, messages } = action.payload;
      const folderId = folder.folderId;

      // Copia superficial del estado y del cache
      const newUpdateState = { ...state };
      newUpdateState.cache = { ...newUpdateState.cache };

      // Copia profunda del folder cache
      const prevFolderCache = newUpdateState.cache[folderId] || {};
      const folderCacheCopy = { ...prevFolderCache };
      messages
        .filter(m => !m.messageId || !newUpdateState.locked.includes(m.messageId))
        .forEach(m => {
          folderCacheCopy[m.uid] = m;
        });
        
      newUpdateState.cache[folderId] = folderCacheCopy;
      return newUpdateState;
    }
    case ActionTypes.MESSAGES_UPDATE_CACHE_IF_EXIST: {
      const newUpdateState = { ...state };
      newUpdateState.cache = { ...newUpdateState.cache };
      const folderId = action.payload.folder.folderId;
      if (typeof newUpdateState.cache[folderId] === 'object') {
        // Copia profunda del folder cache
        const prevFolderCache = newUpdateState.cache[folderId] || {};
        const folderCacheCopy = { ...prevFolderCache };
        let messagesToUpdate;
        if (action.payload.ignoreLocked) {
          messagesToUpdate = action.payload.messages;
        } else {
          messagesToUpdate = action.payload.messages.filter(
            m => !m.messageId || !newUpdateState.locked.includes(m.messageId)
          );
        }
        messagesToUpdate.forEach(m => {
          if (folderCacheCopy[m.uid]) {
            folderCacheCopy[m.uid] = m;
          }
        });
        newUpdateState.cache[folderId] = folderCacheCopy;
      }
      return newUpdateState;
    }
    case ActionTypes.MESSAGES_DELETE_FROM_CACHE: {
      const newUpdateState = { ...state };
      const folderId = action.payload.folder.folderId;
      if (typeof newUpdateState.cache[folderId] !== 'object') {
        return state;
      }
      newUpdateState.cache = { ...newUpdateState.cache };
      // Copia profunda del folder cache
      const prevFolderCache = newUpdateState.cache[folderId] || {};
      const folderCacheCopy = { ...prevFolderCache };

      // Delete unitary messages
      action.payload.messages.forEach(m => {
        delete folderCacheCopy[m.uid];
      });

      // Delete UID range
      const { deleteUidRange } = action.payload;
      if (deleteUidRange) {
        let toDeleteUids = Object.keys(folderCacheCopy);
        if (deleteUidRange.from || deleteUidRange.from === 0) {
          toDeleteUids = toDeleteUids.filter(
            uid => uid >= deleteUidRange.from
          );
        }
        if (deleteUidRange.to || deleteUidRange.to === 0) {
          toDeleteUids = toDeleteUids.filter(uid => uid <= deleteUidRange.to);
        }
        toDeleteUids.forEach(uid => {
          delete folderCacheCopy[uid];
        });
      }
      newUpdateState.cache[folderId] = folderCacheCopy;
      return newUpdateState;
    }
    case ActionTypes.MESSAGES_RENAME_CACHE: {
      const newState = { ...state };
      if (newState.cache[action.payload.oldId]) {
        newState.cache = { ...newState.cache };
        newState.cache[action.payload.newId] =
          newState.cache[action.payload.oldId];
        delete newState.cache[action.payload.oldId];
      }
      return newState;
    }
    case ActionTypes.MESSAGES_SET_SELECTED: {
      const newUpdateState = { ...state };
      newUpdateState.selected = [...state.selected];
      newUpdateState.selectedMessages = [...state.selectedMessages];
      action.payload.messages.forEach(message => {
        let messageSelected;
        let tempMsgId;
        if (message.messageId) {
          messageSelected = newUpdateState.selected.find(s => s.messageId === message.messageId);
        } else {
          tempMsgId = `${message.subject}||-||${message.receivedDate}`;
          messageSelected = newUpdateState.selected.find(s => s.messageId === tempMsgId);
        }
        if (action.payload.selected && !messageSelected) {
          // Select Message
          if (message.messageId !== null) {
            newUpdateState.selected.push({
              ...message,
              messageId: message.messageId,
              folderId: action.payload.folderId
              // uid: action.payload.uid
            });
          } else {
            newUpdateState.selected.push({
              ...message,
              messageId: tempMsgId,
              folderId: action.payload.folderId,
              uid: action.payload.uid
            });
          }
        } else if (!action.payload.selected) {
          // Unselect message
          if (message.messageId !== null) {
            newUpdateState.selected = newUpdateState.selected.filter(msg => msg.messageId !== message.messageId);
          } else {
            newUpdateState.selected = newUpdateState.selected.filter(msg => msg.messageId !== tempMsgId);
          }
        }

        if (action.payload.selected) {
          // Select Message
          const data = {
            id: (message.messageId !== null) ? message.messageId : tempMsgId,
            subject: message.subject,
            sentDateTime: message.receivedDate,
            folder: action.payload.folderName,
            raw: message.raw
          };
          if (message.messageId !== null) {
            newUpdateState.selectedMessages = [
              ...newUpdateState.selectedMessages.filter(
                msg => msg.id !== message.messageId
              ),
              data
            ];
          } else {
            newUpdateState.selectedMessages = [
              ...newUpdateState.selectedMessages.filter(
                msg => msg.id !== tempMsgId
              ),
              data
            ];
          }
        } else if (!action.payload.selected) {
          // Unselect message
          if (message.messageId !== null) {
            newUpdateState.selectedMessages = newUpdateState.selectedMessages.filter(
              e => e.id !== message.messageId
            );
          } else {
            newUpdateState.selectedMessages = newUpdateState.selectedMessages.filter(
              e => e.id !== tempMsgId
            );
          }
        }
      });
      return newUpdateState;
    }
    case ActionTypes.ADD_MESSAGE_CLASSIFICATION: {
      const newUpdateState = { ...state };
      newUpdateState.selectedMessages = [...state.selectedMessages];
      action.payload.messages.forEach(message => {
        // Select Message
        const data = {
          ...message
        };
        newUpdateState.selectedMessages = [
          ...newUpdateState.selectedMessages.filter(
            msg => msg.id !== message.id && msg.idActuation !== message.idActuation
          ),
          data
        ];
      });
      return newUpdateState;
    }
    case ActionTypes.MESSAGES_CLEAR_SELECTED: {
      const newUpdateState = { ...state, selected: [], selectedMessages: [] };
      return newUpdateState;
    }
    case ActionTypes.MESSAGES_CLEAR_OPENED_AND_RECOVER_SELECTED: {
      const newUpdateState = { ...state, selected: state.selected.filter(id => id !== action.payload)};
      return newUpdateState;
    }
    case ActionTypes.MESSAGES_LOCK_ADD: {
      const newState = { ...state };
      newState.locked = [
        ...newState.locked,
        ...action.payload
          .filter(m => m.messageId && m.messageId.length > 0)
          .map(m => m.messageId)
      ];
      return newState;
    }
    case ActionTypes.MESSAGES_LOCK_REMOVE: {
      const newState = { ...state };
      const remainingItems = [
        ...action.payload
          .filter(m => m.messageId && m.messageId.length > 0)
          .map(m => m.messageId)
      ];
      newState.locked = [];
      for (const messageId of state.locked) {
        const i = remainingItems.indexOf(messageId);
        if (i > -1) {
          remainingItems.splice(i, 1);
        } else {
          newState.locked.push(messageId);
        }
      }
      return newState;
    }
    case ActionTypes.SET_SIDEBAR_OPEN_CALENDAR:
      return {
        ...state,
        sidebarCalendarDocked: action.payload
      };
    case ActionTypes.SET_SIDEBAR_OPEN_CENTINELA:
      return {
        ...state,
        sidebarCentinelaDocked: action.payload
      };
    case ActionTypes.SET_SIDEBAR_OPEN_DATABASE:
      return {
        ...state,
        sidebarDatabaseDocked: action.payload
      };
    case ActionTypes.SET_SIDEBAR_OPEN_LEXON:
      return {
        ...state,
        sidebarLexonDocked: action.payload
      };
    case ActionTypes.SET_IS_FULL_MESSAGE_CONTENT:
      return {
        ...state,
        isFullMessageContent: action.payload
      };
    case ActionTypes.MESSAGES_CLEAR_FILTERED_MESSAGES:
      return {
        ...state,
        selected: [],
        selectedMessages: []
      };
    default:
      return state;
  }
};

export default messages;